/**
 * Écriture inclusive (FR) : point médian sur les rôles + reformulations épicènes pour le tutoiement.
 * Utilisé quand la préférence profil « écriture inclusive » est activée.
 */

/** Correspondance exacte (phrases longues ou formulations sensibles). */
const INCLUSIVE_PHRASE_OVERRIDES: Record<string, string> = {
  'Dresseur': 'Dresseur·euse',
  'Nom de dresseur': 'Nom de dresseur·euse',
  'Niveau dresseur': 'Niveau dresseur·euse',
  'Niveau Dresseur': 'Niveau dresseur·euse',
  'Joueurs': 'Joueur·euses',
  'joueurs': 'joueur·euses',
  'Bienvenue ! Choisissez votre pseudo de dresseur.': 'Bienvenue ! Choisissez votre pseudo de dresseur·euse.',
  'Adresse e-mail invalide (ex. dresseur@exemple.com).':
    'Adresse e-mail invalide (ex. dresseur·euse@exemple.com).',
  'Certains bonbons ne sont pas encore débloqués à ton niveau de joueur.':
    'Certains bonbons ne sont pas encore débloqués à ton niveau de joueur·euse.',
  'Réinitialiser efface toute ta progression (Pokémon, or, succès, etc.). Ton compte et ton pseudo restent. La suppression retire définitivement ton compte.':
    'Réinitialiser efface toute la progression (Pokémon, or, succès, etc.). Le compte et le pseudo restent. La suppression retire définitivement le compte.',
  'Tout sera remis à zéro : équipe, inventaire, succès, Pokédex, or, etc. Ton email et ton pseudo ne changent pas.':
    'Tout sera remis à zéro : équipe, inventaire, succès, Pokédex, or, etc. L’e-mail et le pseudo ne changent pas.',
  'Cette action est irréversible. Toutes tes données seront effacées.':
    'Cette action est irréversible. Toutes les données du compte seront effacées.',
  'Impossible de charger ton classement.': 'Impossible de charger le classement.',
  'Construis ton équipe et grimpe dans le classement.':
    'Construis l’équipe et grimpe dans le classement.',
  'Connecte-toi pour reprendre instantanément ta progression et optimiser ton farm.':
    'Connecte-toi pour reprendre instantanément la progression et optimiser le farm.',
  'Invoque des Pokémon pour renforcer ton équipe !':
    'Invoque des Pokémon pour renforcer l’équipe !',
  'Renforce ton équipe pour atteindre le seuil.': 'Renforce l’équipe pour atteindre le seuil.',
  'Ajoute au moins un Pokémon dans ton équipe pour lancer un raid.':
    'Ajoute au moins un Pokémon dans l’équipe pour lancer un raid.',
  'Aucun Pokémon de cette équipe n’a été trouvé dans ta collection.':
    'Aucun Pokémon de cette équipe n’a été trouvé dans la collection.',
  'Équipe chargée dans ta team active.': 'Équipe chargée dans l’équipe active.',
  '✨ Shiny obtenu ! Consulte ton inventaire.': '✨ Shiny obtenu ! Consulte l’inventaire.',
  'Le serveur calcule tes gains pendant ton absence…':
    'Le serveur calcule les gains pendant l’absence…',
  'Récap de ton absence — l’or est déjà sur ton compte. Onglet ouvert en arrière-plan = bonus.':
    'Récap de l’absence — l’or est déjà sur le compte. Utilise Déconnexion pour les gains offline.',
  'Lance le boss sans confirmation si ton DPS estimé suffit.':
    'Lance le boss sans confirmation si le DPS estimé suffit.',
  'Retourne à ta dernière route de farm au lieu de retenter en boucle.':
    'Retourne à la dernière route de farm au lieu de retenter en boucle.',
  'On récupère ta progression serveur. Le jeu reste bloqué pour éviter de repartir sur une sauvegarde vide.':
    'On récupère la progression serveur. Le jeu reste bloqué pour éviter de repartir sur une sauvegarde vide.',
  'Choisis ton Pokémon de départ pour cette région. Il rejoindra automatiquement ton équipe !':
    'Choisis un Pokémon de départ pour cette région. Il rejoindra automatiquement l’équipe !',
  'Tu peux farmer sur une autre route pour préparer ton équipe, puis reprendre l’épreuve quand tu es prêt.':
    'Tu peux farmer sur une autre route pour préparer l’équipe, puis reprendre l’épreuve quand tu es prêt·e.',
  'Obtenir 75 badges ou niveau dresseur 100': 'Obtenir 75 badges ou niveau dresseur·euse 100',
  'Personnalise ton identité visuelle sans toucher au gameplay.':
    'Personnalise l’identité visuelle sans toucher au gameplay.',
  'Ajuste les effets cosmétiques et le contraste HUD selon ton confort.':
    'Ajuste les effets cosmétiques et le contraste HUD selon le confort.',
  'Ce thème sera débloqué définitivement sur ton compte.':
    'Ce thème sera débloqué définitivement sur le compte.',
  'Aucun titre ne correspond à ta recherche.': 'Aucun titre ne correspond à la recherche.',
  'Filtre sur ta progression active.': 'Filtre sur la progression active.',
  'Pension pleine : tes choix iront dans l’ordre de priorité.':
    'Pension pleine : les choix iront dans l’ordre de priorité.',
  'Chaque slot avance avec tes dégâts de combat. Une espèce terminée en shiny 5★ sort automatiquement de la rotation.':
    'Chaque slot avance avec les dégâts de combat. Une espèce terminée en shiny 5★ sort automatiquement de la rotation.',
  'Le remplissage automatique des slots libres est désactivé : seuls tes dépôts manuels, la file de priorité ou le bouton Remplir ajoutent des Pokémon.':
    'Le remplissage automatique des slots libres est désactivé : seuls les dépôts manuels, la file de priorité ou le bouton Remplir ajoutent des Pokémon.',
  'Éclot les œufs prêts puis relance la production avec tes priorités et les meilleurs candidats.':
    'Éclot les œufs prêts puis relance la production avec les priorités et les meilleurs candidats.',
  'Les éclats du sanctuaire récompensent ta constance.':
    'Les éclats du sanctuaire récompensent la constance.',
  'Farm l’étape 5 ou renforce ton équipe avant le boss.':
    'Farm l’étape 5 ou renforce l’équipe avant le boss.',
  'Suivis par le jeu, jamais imposés — choisis ta propre fin.':
    'Suivis par le jeu, jamais imposés — choisis une fin personnelle.',
  'Aucun ami pour le moment. Ajoute des joueurs avec leur pseudo !':
    'Aucun·e ami·e pour le moment. Ajoute des joueur·euses avec leur pseudo !',
  'Répartition des choix de départ par région (min. 8 joueurs ayant choisi dans cette génération)':
    'Répartition des choix de départ par région (min. 8 joueur·euses ayant choisi dans cette génération)',
  'Hall d’ascension : seuls les joueurs en NG+ apparaissent ici.':
    'Hall d’ascension : seuls les joueur·euses en NG+ apparaissent ici.',
  'Chat, échanges et défis entre joueurs': 'Chat, échanges et défis entre joueur·euses',
  'Capture, renforce ton équipe, farme à ton rythme et affronte les champions région par région. Que tu aies cinq minutes ou toute la soirée.':
    'Capture, renforce l’équipe, farme à ton rythme et affronte les champions région par région. Que tu aies cinq minutes ou toute la soirée.',
  'Un starter légendaire sur la jaquette. Le reste, c’est ton grind.':
    'Un starter légendaire sur la jaquette. Le reste, c’est le grind.',
  'Contacte l’équipe (Discord du jeu, ticket support, etc.) avec ton pseudo ou ton e-mail d’inscription. Un administrateur pourra réinitialiser ton mot de passe.':
    'Contacte l’équipe (Discord du jeu, ticket support, etc.) avec le pseudo ou l’e-mail d’inscription. Un·e administrateur·rice pourra réinitialiser le mot de passe.',
  'Ta réponse :': 'La réponse :',
  'Obtenir ton premier badge': 'Obtenir le premier badge',
  'Obtenir ton premier shiny': 'Obtenir le premier shiny',
  'Obtenir ton premier légendaire': 'Obtenir le premier légendaire',
  'Atteindre le niveau dresseur 10.': 'Atteindre le niveau dresseur·euse 10.',
  'Atteindre le niveau dresseur 100.': 'Atteindre le niveau dresseur·euse 100.',
  'Atteindre le niveau dresseur 200.': 'Atteindre le niveau dresseur·euse 200.',
  'Atteindre le niveau dresseur 500.': 'Atteindre le niveau dresseur·euse 500.',
  'Obtenir ton premier Pokémon shiny (succès Première Étincelle).':
    'Obtenir le premier Pokémon shiny (succès Première Étincelle).',
  'Obtenir ton premier Pokémon légendaire (succès Contact divin).':
    'Obtenir le premier Pokémon légendaire (succès Contact divin).',
  'Monte ton équipe active au max.': 'Monte l’équipe active au max.',
  'Continue ta progression de badges': 'Continue la progression de badges',
  'Continue ta collection': 'Continue la collection',
  'Augmente ton total de KOs': 'Augmente le total de KOs',
  'Poursuis ta progression Pokédex': 'Poursuis la progression Pokédex',
  'Restaure tous tes cœurs.': 'Restaure tous les cœurs.',
  'Montre que tu as investi tes premiers éclats dans le sanctuaire.':
    'Montre que tu as investi les premiers éclats dans le sanctuaire.',
}

/** Reformulations épicènes (tutoiement) — appliquées avant les termes de rôle. */
const POSSESSIVE_REFORMULATIONS: [RegExp, string][] = [
  [/\bToutes tes données\b/g, 'Toutes les données du compte'],
  [/\btoutes tes données\b/g, 'toutes les données du compte'],
  [/\bToute ta progression\b/g, 'Toute la progression'],
  [/\btoute ta progression\b/g, 'toute la progression'],
  [/\bTes données\b/g, 'Les données du compte'],
  [/\btes données\b/g, 'les données du compte'],
  [/\btes gains\b/g, 'les gains'],
  [/\btes dépôts\b/g, 'les dépôts'],
  [/\btes priorités\b/g, 'les priorités'],
  [/\btes choix\b/g, 'les choix'],
  [/\btes bonbons\b/g, 'les bonbons'],
  [/\btes Pokémon\b/g, 'les Pokémon'],
  [/\btes dégâts\b/g, 'les dégâts'],
  [/\btes invocations\b/g, 'les invocations'],
  [/\btes kills\b/g, 'les kills'],
  [/\btes cœurs\b/g, 'les cœurs'],
  [/\btes éclats\b/g, 'les éclats'],
  [/\btes premiers éclats\b/gi, 'les premiers éclats'],
  [/\bton équipe active\b/gi, "l'équipe active"],
  [/\bton équipe\b/gi, "l'équipe"],
  [/\bton inventaire\b/gi, "l'inventaire"],
  [/\bton compte\b/gi, 'le compte'],
  [/\bton pseudo\b/gi, 'le pseudo'],
  [/\bton e-mail\b/gi, "l'e-mail"],
  [/\bton absence\b/gi, "l'absence"],
  [/\bton DPS\b/gi, 'le DPS'],
  [/\bton farm\b/gi, 'le farm'],
  [/\bton grind\b/gi, 'le grind'],
  [/\bton confort\b/gi, 'le confort'],
  [/\bton classement\b/gi, 'le classement'],
  [/\bton niveau de joueur\b/gi, 'le niveau de joueur·euse'],
  [/\bton niveau\b/gi, 'le niveau'],
  [/\bton premier\b/gi, 'un·e premier·ère'],
  [/\bton Pokémon\b/gi, 'le Pokémon'],
  [/\bta progression\b/gi, 'la progression'],
  [/\bta collection\b/gi, 'la collection'],
  [/\bta team active\b/gi, "l'équipe active"],
  [/\bta dernière route\b/gi, 'la dernière route'],
  [/\bta recherche\b/gi, 'la recherche'],
  [/\bta constance\b/gi, 'la constance'],
  [/\bta maîtrise\b/gi, 'la maîtrise'],
  [/\bta place\b/gi, 'la place'],
  [/\bta propre fin\b/gi, 'une fin personnelle'],
  [/\bta progression active\b/gi, 'la progression active'],
  [/\bta composition\b/gi, 'la composition'],
  [/\bta chance\b/gi, 'la chance'],
  [/\bta progression principale\b/gi, 'la progression principale'],
]

const ROLE_REPLACEMENTS: [RegExp, string][] = [
  [/\bJoueurs\b/g, 'Joueur·euses'],
  [/\bjoueurs\b/g, 'joueur·euses'],
  [/\bJoueur\b/g, 'Joueur·euse'],
  [/\bjoueur\b/g, 'joueur·euse'],
  [/\bDresseurs\b/g, 'Dresseur·euses'],
  [/\bdresseurs\b/g, 'dresseur·euses'],
  [/\bDresseur\b/g, 'Dresseur·euse'],
  [/\bdresseur\b/g, 'dresseur·euse'],
]

export function resolveInclusiveFr(standard: string, explicitInclusive?: string): string {
  if (explicitInclusive !== undefined) return explicitInclusive
  if (INCLUSIVE_PHRASE_OVERRIDES[standard]) return INCLUSIVE_PHRASE_OVERRIDES[standard]

  let out = standard
  for (const [re, repl] of POSSESSIVE_REFORMULATIONS) {
    out = out.replace(re, repl)
  }
  for (const [re, repl] of ROLE_REPLACEMENTS) {
    out = out.replace(re, repl)
  }
  return out
}
